import enUS from './en-US.js'
import zhCN from './zh-CN.js'
import ptBR from './pt-BR.js'
import esMX from './es-MX.js'
import jaJP from './ja-JP.js'
import ruRU from './ru-RU.js'
import arEG from './ar-EG.js'

const locales = {
  'en-US': enUS,
  'zh-CN': zhCN,
  'pt-BR': ptBR,
  'es-MX': esMX,
  'ja-JP': jaJP,
  'ru-RU': ruRU,
  'ar-EG': arEG
}

export default locales


// import enUS1 from './i18n/en-US.js'
// import zhCN1 from './i18n/zh-CN.js'
// import ptBR1 from './i18n/pt-BR.js'
// import esMX1 from './i18n/es-MX.js'
// import jaJP1 from './i18n/ja-JP.js'
// import ruRU1 from './i18n/ru-RU.js'

// const locales = {
//   'en-US': { ...enUS, ...enUS1 },
//   'zh-CN': { ...zhCN, ...zhCN1 },
//   'pt-BR': { ...ptBR, ...ptBR1 },
//   'es-MX': { ...esMX, ...esMX1 },
//   'ja-JP': { ...jaJP, ...jaJP1 },
//   'ru-RU': { ...ruRU, ...ruRU1 }
// }

